import env from './env';
export const API_URL = env.API_URL;
export const API_BASE_URL = env.API_BASE_URL;
export const MEDIA_SERVER_API_URL = env.MEDIA_SERVER_API_URL;
export const MS_URL = `https://${window.location.host}/`;
export const SOCKET_ENDPOINT = env.SOCKET_URL;
export const CLIENT_ID = env.CLIENT_ID;
export const AUTHORITY = env.AUTHORITY;
export const API_SCOPES = env.API_SCOPES;
export const MS_CONSOLE_TITLE = env.NAME;